import React, { useState } from 'react';
import cn from 'classnames';
import { Container } from 'components/UI';
import { Image, Title } from '@landing/ui';
import GalleryModal from './GalleryModal';
import { useStateModal, useWindowResize } from 'utils/hooks';
import { scrollToAnchor } from 'utils/scroll';

import * as styles from './Gallery.module.scss';

const SHOW_COUNTER_STEP = 5;
const GALLERY_ID = 'photo-gallery';

export default function Gallery({ title, items = [] }) {
  const { width } = useWindowResize();
  const { modalState, showModal, hideModal } = useStateModal();
  const isMobile = width < 545;

  const [showCounter, setShowCounter] = useState(SHOW_COUNTER_STEP);
  const [clickedImageIndex, setClickedImageIndex] = useState(0);

  const seeMoreCounter = (items.length - showCounter) / SHOW_COUNTER_STEP;
  const showMoreButton = Boolean(seeMoreCounter);
  const showHideButton = showCounter > SHOW_COUNTER_STEP;

  const getImageSize = index => {
    if (isMobile) {
      if (index === 0 || index % 5 === 0) {
        return 'large';
      }
      if (
        index === 2 ||
        index === 3 ||
        index === 7 ||
        index === 8 ||
        index === 12 ||
        index === 13
      ) {
        return 'medium';
      }
      return 'small';
    }

    if (index === 0 || index === 7 || index === 10) {
      return 'large';
    }
    if (index === 2 || index === 3 || index === 5 || index === 9 || index === 12 || index === 13) {
      return 'medium';
    }
    return 'small';
  };

  const seeMoreHandler = () => {
    setShowCounter(prev => prev + SHOW_COUNTER_STEP);
  };

  const hideAllHandler = () => {
    setShowCounter(SHOW_COUNTER_STEP);
    scrollToAnchor(GALLERY_ID);
  };

  const clickImageHandler = index => {
    setClickedImageIndex(index);
    showModal();
  };

  return (
    <Container id={GALLERY_ID} background="transparent">
      <div className={styles.layout}>
        <Title color="white">{title}</Title>
        <div className={styles.gallery}>
          {items.slice(0, showCounter).map(({ image, alt }, index) => {
            const size = getImageSize(index);

            return (
              <button
                key={`gallery-${index}`}
                className={cn(styles.imageWrapper, size && styles[size])}
                onClick={() => clickImageHandler(index)}
              >
                <Image className={styles.picture} classImage={styles.image} src={image} alt={alt} />
              </button>
            );
          })}
        </div>
        {(showMoreButton || showHideButton) && (
          <div className={styles.buttonsRow}>
            {showMoreButton && (
              <button className={styles.seeMoreButton} onClick={seeMoreHandler}>
                See more ({seeMoreCounter})
              </button>
            )}
            {showHideButton && (
              <button className={styles.hideAllButton} onClick={hideAllHandler}>
                Hide all
              </button>
            )}
          </div>
        )}
      </div>
      <GalleryModal
        isOpen={modalState.isOpen}
        closeModalCallback={hideModal}
        items={items}
        initialSlide={clickedImageIndex}
      />
    </Container>
  );
}
